import * as React from 'react';
import { useSelector } from 'react-redux';
import { useIsMobileDevice } from '../../hooks';
import { selectIsAutoProlongAvailable } from '../../selectors/checkoutInfo';
import { selectCheckoutDetails } from '../../selectors/publishTerms';
import { Checkout } from './Checkout';

export const CheckoutContainer = () => {
  const details = useSelector(selectCheckoutDetails);
  const isAutoProlongAvailable = useSelector(selectIsAutoProlongAvailable);
  const isMobile = useIsMobileDevice();

  return <Checkout details={details} isAutoProlongVisible={!isMobile && isAutoProlongAvailable} />;
};
